/** Search params used in the site zones API. */
export const searchParametersZoneApi = {
    MANAGER: 'client__id',
}
